<template>
    <div>
        <v-btn
            icon
            dark
            small
            color="white"
            class="close-btn close-btn-left d-none d-md-block"
            elevation="1"
            @click="closeDictionary">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <UtilsContent @close-action="closeDictionary">
            <template v-slot:header>
                <div class="d-flex flex-column justify-center align-start">
                    <div class="d-flex flex-row justify-start align-center mx-3 mb-4">
                        <img :src="dictionaryImg" class="img-index mr-2" alt="" />
                        <div class="align-middle text-left line-height-100">
                            <p class="font-size-16 font-weight-bolder ma-0 text--primary">
                                {{ $t('bookReading.dictionary') }}
                            </p>
                            <small class="font-size-12">Dictionary</small>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:content>
                <div class="d-flex flex-column mx-3">
                    <v-row justify="start" align="start">
                        <v-col cols="12" class="text-left">
                            <label>{{$t('bookReading.dictionary_msg_1')}}</label>
                            <v-text-field
                                data-cy="dictionary-input-text"
                                label=""
                                outlined
                                class="white"
                                color="primary"
                                hide-details
                                clearable
                                :placeholder="$t('bookReading.dictionary_placeholder')"
                                @click:clear="clear"
                                v-model="st.word"
                            />
                        </v-col>
                    </v-row>
                    <v-row
                        data-cy="dictionary-content-results"
                        justify="start"
                        align="start"
                        v-if="dictionary_data.length"
                        class="dictionary-content"
                    >
                        <v-col cols="12" v-for="(meaning, index) of dictionary_data" :key="index">
                            <MeaningItem :data="meaning" />
                        </v-col>
                    </v-row>
                    <v-row v-if="noMeaning">
                        {{ $t('bookReading.no_meaning') }}
                    </v-row>
                    <v-row v-if="notAvailable">
                        {{ $t('bookReading.not_available') }}
                    </v-row>
                </div>
            </template>
            <template v-slot:actions>
                <v-col justify="center" align="center" class="position-relative" v-if="!dictionary_data.length">
                    <v-btn
                        data-cy="dictionary-search-button"
                        dark
                        rounded
                        class="w-100 py-5 bg-gradient-primary"
                        :disabled="st.word.length < 3"
                        :loading="btnLoading"
                        @click="search"
                    >
                        {{ $t('bookReading.search_word') }}
                    </v-btn>
                    <span>{{ $t('bookReading.search_word') }}</span>
                </v-col>
            </template>
        </UtilsContent>
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState, mapActions } from 'vuex';
import * as Sentry from '@sentry/vue';
import global from '@/constants/GlobalConstant';
import UtilsContent from '@/components/core/utils/UtilsContent.vue';
import dictionaryService from '@/services/dictionary';
import MeaningItem from './MeaningItem.vue';

export default {
    components: {
        UtilsContent,
        MeaningItem,
    },
    computed: {
        ...mapState({
            st: (state) => state.bookReading,
            dictionaryMode: (state) => state.bookReading.dictionaryMode,
            word: (state) => state.bookReading.word,
        }),
    },
    mounted() {
        if (this.dictionaryMode === 'auto') this.search()
    },
    data() {
        return {
            dictionaryImg: require('@/assets/img/icons/new-reading/dictionary-purple.svg'),
            global,
            dictionary_data: [],
            btnLoading: false,
            noMeaning: false,
            notAvailable: false,
        }
    },
    methods: {
        ...mapActions('bookReading', ['setWord']),
        closeDictionary() {
            this.clear()
            this.$emit('close-dictionary')
        },
        clear() {
            this.setWord('')
            this.dictionary_data.length = 0
        },
        onNewSearch() {
            this.btnLoading = true;
            this.dictionary_data.length = 0;
            this.notAvailable = false;
            this.noMeaning = false;
        },
        async search() {
            this.onNewSearch();
            const vm = this;
            const response = await dictionaryService.getMeaning(this.word)
                .catch((error) => Sentry.captureException(error))
                .finally(() => this.btnLoading = false);

            if (!response || response.status.code === 3) {
                this.notAvailable = true;
                return;
            }
            if (response.content === '404') {
                this.noMeaning = true;
                return;
            }
            response.content.results.forEach(item => {
                item.lexicalEntries.forEach(lexicals => {
                    if (lexicals.lexicalCategory.text !== 'Other' && lexicals.entries) {
                        const word = {
                            word: item.word,
                            origin: lexicals.lexicalCategory.text,
                            name: lexicals.lexicalCategory.text,
                            definitions: lexicals.entries[0].senses
                        };
                        vm.dictionary_data.push(word);
                    }
                });
            });
        },
    },
}
</script>
<style lang="scss" scoped>
.chapters-container {
    height: 35vh;
    max-height: 35vh;
    overflow: auto;
}

.dictionary-content {
    height: 55vh;
    max-height: 55vh;
    overflow: auto;
}
::v-deep .v-btn--disabled{
    position: relative;
    opacity: .3;
    .v-btn__content{
        display: none;
    }
}
.bg-gradient-primary + span{
    display: none;
}
.v-btn--disabled.bg-gradient-primary + span{
    display: block;
    color: white;
    font-weight: 500;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 1;
    z-index: 5;
}
</style>
